'use strict';

const HomeyAPIV3Manager = require('../HomeyAPIV3/Manager');

/**
 * @class
 * @extends HomeyAPIV3.Manager
 * @hideconstructor
 * @memberof HomeyAPIV3Local
 */
class Manager extends HomeyAPIV3Manager {

}

module.exports = Manager;
